module.exports = __webpack_public_path__ + "img/rate-1.9a6dffc2.png";